
  import { Component, Prop, Vue } from 'vue-property-decorator'

  @Component
  export default class VComponent extends Vue {

    @Prop({ type: String, default: ''}) private readonly heading!: string
    @Prop({ type: String, default: ''}) private readonly link!: string
  }
